import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.all-harvest-trackings-table', () => {
  import('./internal/all-harvest-trackings-table').then(({ default: Component }) => Component());
});
